export default __webpack_public_path__ + "static/media/nms_cash.44a0b743.svg";